import { Tooltip } from '@quicktools/shared-components';
import { clipboardWrite } from '@quicktools/shared-components/utils/text/clipboard';
import useSnackbarStore from '@quicktools/shared-components/hooks/snackbar';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useCallback, useState } from 'react';

import { ISymbol } from '../../data/types';

import useStyles from './style-symbol';
import { ISymbolItem } from './types';

function Symbol({ symbol, click, hover, displayTooltip = false }: ISymbolItem) {
  const styles = useStyles();
  const { t } = useTranslation();
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);
  const snackbarShowWarning = useSnackbarStore((state) => state.snackbarShowWarning);

  const handleClick = useCallback(
    (s: ISymbol) => {
      setShowCopyTooltip(false);

      try {
        clipboardWrite(symbol.value);
        click(s);
        setShowCopiedTooltip(true);
        setTimeout(() => {
          setShowCopiedTooltip(false);
        }, 700);
      } catch (e) {
        snackbarShowWarning(t('error.clipboardCopy'));
        console.warn(e);
      }
    },
    [click],
  );

  const handleMouseEnter = useCallback(() => {
    hover();
    setShowCopyTooltip(true);
  }, [hover]);

  const handleMouseLeave = useCallback(() => {
    setShowCopyTooltip(false);
  }, []);

  return (
    <li
      className={styles.emoji}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => handleClick(symbol)}
    >
      <div className={styles.emojiContent}>
        {displayTooltip && showCopyTooltip && (
          <Tooltip className={classNames(styles.tooltip, styles.tooltipCopy)}>
            Click to copy!
          </Tooltip>
        )}

        {showCopiedTooltip && (
          <Tooltip className={classNames(styles.tooltip, styles.tooltipCopied)} color="magenta">
            Copied!
          </Tooltip>
        )}
        <div>{symbol.value}</div>
      </div>
    </li>
  );
}

export default Symbol;
